<template>    
  <v-dialog
    v-model="dialog"
    hide-overlay
    persistent
    width="400">
    <v-card>
      <v-card-text style="height: 200px">
        <v-container fill-height fluid>
          <v-layout fill-height fluid column>
            <v-flex class="align-text-center">
              <v-progress-circular
                v-if="icon == 'loading'"
                indeterminate
                :size="50"
                :width="5"
                color="blue"
                class="mb-0">
              </v-progress-circular>
              <v-icon
                x-large :color="iconColor"
                v-else>
                {{icon}}
              </v-icon>
            </v-flex>
            <v-flex>
              <div class="label align-text-center">{{label}}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
      }
    },
    props: {
      type: {
        type: String,
        required: true
      },
      shown: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      label () {
        return {
          'loading': 'Verifying...',
          'reject_loading': 'Rejecting...',
          'reject_success': 'Returned to Producer',
          'submitting': 'Submitting...',
          'submitted': 'Transaction in ledger',
          'txn_fail': 'Transaction failed',
          'reject_fail': 'Rejection failed',
          'success': 'Verification Successfull',
          'fail': 'Verification Failed',
        }[this.type]
      },
      icon () {
        return {
          'loading': 'loading',
          'reject_success': 'cancel',
          'submitting': 'loading',
          'submitted': 'check_circle',
          'txn_fail': 'error',
          'success': 'check_circle',
          'fail': 'error'
        }[this.type]
      },
      iconColor () {
        return {
          'check_circle': '#51a350',
          'error': '#ff7f00',
          'cancel': '#f43838'
        }[this.icon]
      }
    },
    watch: {
      shown (val) {
        this.dialog = this.shown
      },
    },
  }
</script>

<style scoped>
  .label{
    font-weight: 400;
    font-size: 25px;    
  }

  .v-icon{
    font-size: 68px !important;
  }

  .align-text-center{
    text-align: center;
  }
</style>
